import { render, staticRenderFns } from "./editHuangjingtupian.vue?vue&type=template&id=76ec3f5a&scoped=true"
import script from "./editHuangjingtupian.vue?vue&type=script&lang=js"
export * from "./editHuangjingtupian.vue?vue&type=script&lang=js"
import style0 from "./editHuangjingtupian.vue?vue&type=style&index=0&id=76ec3f5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ec3f5a",
  null
  
)

export default component.exports